// BusSoft API
export const BUS_SOFT_API = process.env.REACT_APP_BUS_SOFT_API;

// Proxy API - javni pristup bez autentifikacije (bussoft CF dodaje auth server-side)
export const PROXY_API = process.env.REACT_APP_PROXY_API;

// Payten HTTP Cloud Function base URL
// npr. https://europe-west1-busgo-travel.cloudfunctions.net/payten
// ili http://localhost:5001/busgo-travel/europe-west1/payten (emulator)
export const PAYTEN_API = process.env.REACT_APP_PAYTEN_API;

// Online HTTP Cloud Function base URL — orchestrator za online prodaju karata
// npr. https://europe-west1-busgo-travel-staging.cloudfunctions.net/online
// ili http://127.0.0.1:5001/busgo-travel-staging/europe-west1/online (emulator)
export const ONLINE_API = process.env.REACT_APP_ONLINE_API;

// Firebase App Check (reCAPTCHA v3) site key. Bez ključa u env-u App Check se
// ne inicijalizuje i zahtevi idu bez X-Firebase-AppCheck headera.
export const APPCHECK_SITE_KEY = process.env.REACT_APP_APPCHECK_SITE_KEY;

// Fiskalizacija u test režimu (testni TaxCore sertifikat). Default FALSE —
// staging ga EKSPLICITNO uključuje sa REACT_APP_FISCAL_TEST_MODE=true.
// Namerno "=== true" a ne "!== false": zaboravljen env ne sme da znači
// test fiskalizaciju u produkciji.
export const FISCAL_TEST_MODE = process.env.REACT_APP_FISCAL_TEST_MODE === "true";

// Režim održavanja iz builda: dok stoji "true", sajt prikazuje stranicu održavanja
// bez obzira na /maintenance.json. Koristi se dok produkcijska prodaja nije spremna;
// hitno paljenje/gašenje posle lansiranja ide kroz taj JSON, bez novog builda.
export const MAINTENANCE_FORCED = process.env.REACT_APP_MAINTENANCE === "true";

// Firebase projekat busgo-travel - za klijentsku autentifikaciju (login, register, Google)
export const FIREBASE_API = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const PATH_AFTER_LOGIN = "/";

export const HEADER = {
    H_MOBILE: 64,
    H_MAIN_DESKTOP: 72,
};

// Verzija web klijenta — šalje se u /reserve radi dijagnostike u adminu.
export const APP_VERSION = process.env.REACT_APP_VERSION || "1.0.0";
